import React, {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'

import client from '../../axios'
import './styles.css'
import {Link} from 'react-router-dom'
import InfoModal from "../common-modals/info-modal";
import {Modal} from "react-bootstrap";
import PrimaryButton from "../../pages/master/atom/buttons/PrimaryButton";

const LoginForm = () => {

  /* 기존 상태 관리 로직은 그대로 유지합니다 */
  const checkboxRef = useRef<HTMLInputElement>(null)
  const [loginFailed, setLoginFailed] = useState({ failed: false, message: '' })
  const [userInfo, setUserInfo] = useState({ id: '', pwd: '', user_nm: '' });
  const [pwdSet, setPwdSet] = useState('');
  const [pwdFailed, setPwdFailed] = useState(false);
  const [openSetPwd, setOpenSetPwd] = useState(false);
  const [openSetPwdSuccess, setOpenSetPwdSuccess] = useState(false);

  const idInput = useRef<HTMLInputElement>(null),
    pwdInput = useRef<HTMLInputElement>(null),
    loginButton = useRef<HTMLButtonElement>(null)
  
  const navigate = useNavigate()

  useEffect(() => {
    setUserInfo({...userInfo, id: localStorage.getItem("id") !== null ? localStorage.getItem("id") as string : ""})
  }, [])

  const onEnterKeyPress = async (e: any) => {
    if (e.key === 'Enter') {
      switch (document.activeElement?.id) {
        case 'id':
          pwdInput.current?.focus()
          break
        case 'pwd':
          loginButton.current?.focus()
          break
        default:
      }
    }
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInfo({ ...userInfo, [e.target.id]: e.target.value })
  }

  const handleChangeOnID = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInfo({...userInfo, id: e.target.value})
  }

  const requestLogin = async () => {
    try {
      const response = await client.post('/api/auth/login-request', {
        id: userInfo.id,
        pwd: userInfo.pwd,
      })

      switch (response.data.result) {
        case 'success':
          if (checkboxRef.current) {
            if (checkboxRef.current.checked) {
              localStorage.setItem("id", userInfo.id)
            } else
              localStorage.removeItem("id")
          }
          if (response.data.payload.admin_gbn === '0') {
            navigate('/master')
          } else {
            navigate('/')
          }
          break
        case 'failed':
          setLoginFailed({ failed: true, message: '계정 정보를 찾을 수 없습니다.' })
          break
        case 'setPwd':
          setLoginFailed({ failed: true, message: "비밀번호 설정이 필요합니다." });
          break;
        case 'error':
          setLoginFailed({ failed: true, message: '서버에 문제가 발생하였습니다.' })
      }
    } catch (e: any) {
      setLoginFailed({ failed: true, message: '에러가 발생하였습니다.' })
    }
  }

  async function handleCheckPwdSet() {
    try {
      const res = await client.get('/api/auth/check-pwd-set', { params: { id: userInfo.id }});
      if (res.data) {
        setLoginFailed({failed: false, message: ''});
        setOpenSetPwd(true);
      } else {
        setLoginFailed({ failed: true, message: '비밀번호가 이미 설정되어 있습니다.' })
      }
    } catch(e) {
      setLoginFailed({ failed: true, message: '계정이 존재하지 않습니다.' })
    }
  }

  async function handleSavePwd() {
    if (pwdSet.length === 0) {
      setPwdFailed(true);
    } else {
      await client.put('/api/auth/pwd', { id: userInfo.id, pwd: pwdSet });
      setPwdSet('');
      setPwdFailed(false);
      setOpenSetPwd(false);
      setOpenSetPwdSuccess(true);
    }
  }

  return (
    <>
      <div className="w-100">
        <h4 className="fw-bold mb-4" style={{ color: '#2b2b2b', letterSpacing: '-0.5px' }}>로그인</h4>

        {/* 아이디 입력칸 */}
        <div className="mb-3">
          <input id="id" type="text" onChange={handleChangeOnID} autoFocus onKeyDown={onEnterKeyPress} ref={idInput}
                 value={userInfo.id}
                 className={`form-control form-control-lg rounded-pill ${loginFailed.failed ? 'is-invalid border-danger' : 'border-0'}`}
                 style={{ backgroundColor: '#eef1f6', fontSize: '0.95rem', padding: '0.8rem 1.5rem' }}
                 placeholder="아이디를 입력하세요"/>
        </div>

        {/* 비밀번호 입력칸 */}
        <div className="mb-3">
          <input id="pwd" type="password" onChange={onChange} onKeyDown={onEnterKeyPress} ref={pwdInput}
                 className={`form-control form-control-lg rounded-pill ${loginFailed.failed ? 'is-invalid border-danger' : 'border-0'}`}
                 style={{ backgroundColor: '#eef1f6', fontSize: '0.95rem', padding: '0.8rem 1.5rem' }}
                 placeholder="비밀번호를 입력하세요"/>
        </div>

        {/* 에러 메시지 출력 영역 */}
        {loginFailed.failed && (
          <div className="mb-3 px-3 text-start">
            <label className="text-danger" style={{ fontSize: '0.85rem' }}>{loginFailed.message}</label>
          </div>
        )}

        {/* 로그인 버튼 (그라데이션 스타일) */}
        <button id="loginButton" className="btn btn-lg w-100 rounded-pill text-white fw-bold mt-2 mb-4 shadow-sm"
                ref={loginButton} onClick={requestLogin}
                style={{ 
                  background: 'linear-gradient(90deg, #0052D4 0%, #4364F7 50%, #6FB1FC 100%)', 
                  border: 'none', 
                  padding: '0.8rem' 
                }}>
          로그인
        </button>

        {/* 하단 옵션 (아이디 저장 및 비밀번호 생성) */}
        <div className="d-flex justify-content-between px-3" style={{ fontSize: '0.9rem', color: '#6c757d' }}>
          <div className="form-check d-flex align-items-center gap-2">
            <input id="check" type="checkbox" ref={checkboxRef} className="form-check-input mt-0"
                   defaultChecked={localStorage.getItem("id") !== null} 
                   style={{ cursor: 'pointer' }}/>
            <label className="form-check-label" htmlFor="check" style={{ cursor: 'pointer' }}>아이디저장</label>
          </div>
          
          <div onClick={handleCheckPwdSet} style={{ cursor: 'pointer' }}>
            비밀번호 생성
          </div>
        </div>
      </div>

      {/* 기존 모달들은 그대로 유지 */}
      <Modal show={openSetPwd} centered>
        <Modal.Header>비밀번호 설정하기</Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-center align-items-center mb-2'>
            <p style={{ width: 100 }} className='mb-0'>비밀번호: </p>
            <input
              type="password"
              className='form-control form-control-sm'
              style={{ width: 150 }}
              placeholder="비밀번호 입력"
              value={pwdSet}
              onChange={e => setPwdSet(e.target.value)}
            />
          </div>
          <p className='text-danger text-center mt-2' hidden={!pwdFailed} style={{ fontSize: '0.9rem' }}>
            비밀번호를 5자 이상 10자 이하로 설정해주십시오.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setOpenSetPwd(false)}>취소</button>
          <PrimaryButton onClick={handleSavePwd}>확인</PrimaryButton>
        </Modal.Footer>
      </Modal>

      <InfoModal show={openSetPwdSuccess} message="성공적으로 비밀번호가 설정되었습니다." onButtonClick={() => setOpenSetPwdSuccess(false)} />
    </>
  )
}

export default LoginForm